/*
---
name: Shrinker

author:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5: '*'
...
*/

var Shrinker = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_shrinker',
		toggler : null,
		min_height: 20,
		//max_height: 200, //optional
		duration: 300,
		single_opened: true //if true allows to be opened only one element at a time
	},

	initialize: function(element, options){
		this.setOptions(options);
		this._element = element;

		if (this._element){
			this.build();
		}
	},

	build: function(){
		var cls = this.options.cls,
				fcls = '.' + cls;

		if(this.options.single_opened){
			Shrinkers.push(this);
		}

		this._element.setStyle('overflow', 'hidden');

		this.min_height = this.options.min_height;
		this.max_height = this.options.max_height? this.options.max_height : this.get_height();
		this.duration = this.options.duration;

		this._toggler = this._element.getElement(fcls + '_head') || this.options.toggler;
		this._closer = this._element.getElement(fcls + '_close');

		if(this.min_height < this.max_height){
			if(!this._element.hasClass('closed') && !this._element.hasClass('opened'))
				this._element.setStyle('height', this.min_height).addClass('closed');
			else if(this._element.hasClass('opened'))
				this._element.setStyle('height', this.max_height);
			else if(this._element.hasClass('closed'))
				this._element.setStyle('height', this.min_height);

			if(this._toggler){
				this._toggler.addEvent('click',	function(){
					if(this._element.hasClass('closed') && this.options.single_opened){
						Shrinkers.each(function(e){
							if(e._element.hasClass('opened')){
								e.toggle_slide();
							}
						}.bind(this));
					}

					this.toggle_slide();
				}.bind(this));
			}

			if(this._closer){
				this._closer.addEvent('click',
					function(){
						this.toggle_slide();
					}.bind(this));
			}
		}else{
			if(this._toggler) this._toggler.dispose();
			if(this._closer) this._closer.dispose();
		}
	},

	toggle_slide: function(){
		if(this._element.hasClass('closed')){
			this._element.set('tween', {duration: this.duration }).tween('height', this.max_height);

			this._element.removeClass('closed').addClass('opened');

			(function(){
				this.fireEvent('unshrink');
				this._element.setStyle('overflow', 'visible');
			}.bind(this)).delay(this.duration);
		}else{
			this._element.set('tween', {duration: this.duration }).tween('height', this.min_height);
			this._element.setStyle('overflow', 'hidden');
			this._element.removeClass('opened').addClass('closed');

			(function(){
				this.fireEvent('shrink');
			}.bind(this)).delay(this.duration);
		}
	},

	change_head_styles: function(){
		if(this._element.hasClass('closed')){
			this._toggler.removeClass('solid');
		}else{
			this._toggler.addClass('solid');
		}
	},

	get_height: function(){
		return this._element.getSize().y;
	}
});

var Shrinkers = [];
